import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const SITEMAP = [
  {
    heading: 'Studio',
    links: [
      { to: '/crew', label: 'Crew' },
      { to: '/community-impact', label: 'Community Impact' },
      { to: '/contact?reason=contact', label: 'Contact' },
    ],
  },
  {
    heading: 'Work',
    links: [
      { to: '/live-apps', label: 'Live Apps' },
      { to: '/projects', label: 'Projects' },
      { to: '/products', label: 'Pricing' },
    ],
  },
];

const SOCIALS = [
  { href: 'https://www.youtube.com/@Shawny-Media', icon: '/yt.svg', label: 'YouTube' },
  { href: 'https://www.facebook.com/profile.php?id=61589775366026', icon: '/facebook.svg', label: 'Facebook' },
  { href: 'mailto:shawnysmedia@gmail.com', icon: '/mail.svg', label: 'Email' },
];

const Footer = () => (
  <footer className="site-footer">
    <div className="container">
      {/* Closing pitch — the last thing a scroller reads. */}
      <div className="footer-lead">
        <div className="footer-lead-copy">
          <p className="eyebrow">Let's build</p>
          <h2 className="footer-lead-title reveal reveal-up">
            Have something in mind?
            <br />
            <span className="accent-text">Let's scope it out.</span>
          </h2>
        </div>
        <div className="footer-lead-actions reveal reveal-up">
          <Link to="/start" className="btn btn--primary">
            Get started — $100 credit <span className="btn-arrow">→</span>
          </Link>
          <a href="mailto:shawnysmedia@gmail.com" className="btn btn--ghost">
            shawnysmedia@gmail.com
          </a>
        </div>
      </div>

      <hr className="rule" />

      <div className="footer-grid">
        <div className="footer-brand">
          <Link to="/" className="footer-brand-link">
            <img src="/LogoSM.png" alt="" className="footer-brand-logo" />
            <span>ShawnyMedia LLC</span>
          </Link>
          <p className="footer-brand-note">
            Websites, information systems, video, and design — built for businesses and
            nonprofits.
          </p>
          <p className="footer-locale">Corning&ndash;Painted Post, New York</p>
        </div>

        {SITEMAP.map((column) => (
          <nav className="footer-column" key={column.heading} aria-label={column.heading}>
            <h3 className="footer-column-heading">{column.heading}</h3>
            <ul>
              {column.links.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}

        <div className="footer-column">
          <h3 className="footer-column-heading">Elsewhere</h3>
          <ul className="footer-socials">
            {SOCIALS.map((social) => (
              <li key={social.label}>
                <a
                  href={social.href}
                  target={social.href.startsWith('http') ? '_blank' : undefined}
                  rel={social.href.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <img src={social.icon} alt="" className="footer-icon" />
                  {social.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; 2026 ShawnyMedia LLC. All rights reserved.</p>
        <div className="footer-legal">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
